(() => {
  const config = window.ForgeMoly || {};
  const rootUrl = config.root || "/";
  const translations = config.translations || {};
  const translated = (value, replacements = {}) => Object.entries(replacements).reduce((text, [token, replacement]) => text.replaceAll(token, String(replacement)), value || "");
  const money = (cents) => new Intl.NumberFormat(config.locale || "fr-CA", { style: "currency", currency: config.currency || "CAD" }).format((Number(cents) || 0) / 100);
  const escapeHtml = (value) => String(value ?? "").replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[character]);
  const status = document.getElementById("CartStatus");
  const drawer = document.querySelector("[data-cart-drawer]");
  const updateShipping = (element, count) => {
    if (!element) return;
    const canadaThreshold = Number(element.dataset.canadaThreshold || 50);
    const usThreshold = Number(element.dataset.usThreshold || 200);
    const progress = Math.min(100, (count / canadaThreshold) * 100);
    element.style.setProperty("--progress", `${progress}%`);
    const message = element.querySelector("p");
    if (!message) return;
    if (count >= usThreshold) message.textContent = translations.shippingBoth;
    else if (count >= canadaThreshold) message.textContent = translated(translations.shippingCanada, { __COUNT__: usThreshold - count });
    else message.textContent = translated(translations.shippingRemaining, { __CANADA__: canadaThreshold - count, __US__: usThreshold - count });
  };

  const renderCart = (cart) => {
    document.querySelectorAll("[data-cart-count]").forEach((node) => { node.textContent = cart.item_count; });
    const items = drawer?.querySelector("[data-cart-items]");
    if (items) {
      items.innerHTML = cart.item_count === 0 ? `<div class="empty-state"><p>${escapeHtml(translations.emptyCart)}</p><a href="${escapeHtml(config.catalogUrl || `${rootUrl}collections/produits`)}">${escapeHtml(translations.continueShopping)}</a></div>` : cart.items.map((item) => `
        <article class="cart-line" data-line-key="${escapeHtml(item.key)}">
          ${item.image ? `<a href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image)}&width=220" width="110" height="130" alt="${escapeHtml(item.product_title)}"></a>` : ""}
          <div>
            <a href="${escapeHtml(item.url)}"><b>${escapeHtml(item.product_title)}</b></a>
            ${item.variant_title ? `<small>${escapeHtml(item.variant_title)}</small>` : ""}
            <span>${money(item.final_price)}</span>
            <div class="cart-line-actions"><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}">−</button><output>${item.quantity}</output><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}">+</button><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="0">${escapeHtml(translations.remove)}</button></div>
          </div>
        </article>`).join("");
    }
    const subtotal = drawer?.querySelector("[data-cart-subtotal]");
    if (subtotal) subtotal.textContent = money(cart.total_price);
    const checkout = drawer?.querySelector('button[name="checkout"]');
    if (checkout) checkout.disabled = cart.item_count === 0;
    document.querySelectorAll("[data-cart-shipping]").forEach((node) => updateShipping(node, cart.item_count));
  };

  const fetchCart = async () => {
    const response = await fetch(`${rootUrl}cart.js`, { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error(translations.cartLoadError);
    return response.json();
  };

  const openCart = async () => {
    if (!drawer) return;
    try { renderCart(await fetchCart()); } catch (error) { if (status) status.textContent = error.message; }
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    document.querySelectorAll("[data-cart-open]").forEach((button) => button.setAttribute("aria-expanded", "true"));
    drawer.querySelector("[data-cart-close]")?.focus();
  };

  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    document.querySelectorAll("[data-cart-open]").forEach((button) => button.setAttribute("aria-expanded", "false"));
  };

  document.addEventListener("click", async (event) => {
    const openButton = event.target.closest("[data-cart-open]");
    if (openButton) { event.preventDefault(); openCart(); return; }
    if (event.target.closest("[data-cart-close]")) { closeCart(); return; }
    const changeButton = event.target.closest("[data-cart-change]");
    if (changeButton) {
      changeButton.disabled = true;
      try {
        const response = await fetch(`${rootUrl}cart/change.js`, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: changeButton.dataset.cartChange, quantity: Number(changeButton.dataset.quantity) }) });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || translations.cartUpdateError);
        renderCart(cart);
      } catch (error) { if (status) status.textContent = error.message; changeButton.disabled = false; }
    }
  });

  document.addEventListener("keydown", (event) => { if (event.key === "Escape") { closeCart(); document.querySelector(".shop-gallery.is-zoomed")?.classList.remove("is-zoomed"); } });

  document.querySelectorAll("[data-product-root]").forEach((productRoot) => {
    const form = productRoot.querySelector(".shop-product-form");
    const variantsScript = productRoot.querySelector("[data-product-json]");
    if (!form || !variantsScript) return;
    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (_) { return; }
    const variantId = form.querySelector("[data-variant-id]");
    const quantityInput = form.querySelector("[data-quantity-input]");
    const priceNode = productRoot.querySelector("[data-product-price]");
    const totalNode = productRoot.querySelector("[data-product-total]");
    const unitPriceNode = productRoot.querySelector("[data-unit-price]");
    const casePriceNode = productRoot.querySelector("[data-case-price]");
    const addButton = form.querySelector("[data-add-to-cart]");
    const addLabel = form.querySelector("[data-add-label]");
    const availability = productRoot.querySelector("[data-availability]");
    const sku = productRoot.querySelector("[data-product-sku]");
    const barcode = productRoot.querySelector("[data-product-barcode]");
    const productProgress = productRoot.querySelector("[data-shipping-progress]");
    let currentVariant = variants.find((variant) => String(variant.id) === String(variantId.value)) || variants[0];

    const updateProductProgress = () => {
      if (!productProgress) return;
      const canadaThreshold = Number(productProgress.dataset.canadaThreshold || 50);
      const usThreshold = Number(productProgress.dataset.usThreshold || 200);
      const quantity = Number(quantityInput.value || 1);
      if (quantity >= usThreshold) productProgress.innerHTML = `<i></i>${escapeHtml(translations.shippingBoth)}`;
      else if (quantity >= canadaThreshold) productProgress.innerHTML = `<i></i>${escapeHtml(translated(translations.shippingCanada, { __COUNT__: usThreshold - quantity }))}`;
      else productProgress.innerHTML = `<i></i>${escapeHtml(translated(translations.shippingRemaining, { __CANADA__: canadaThreshold - quantity, __US__: usThreshold - quantity }))}`;
      productProgress.classList.toggle("is-complete", quantity >= canadaThreshold);
    };

    const updateProduct = (variant) => {
      currentVariant = variant;
      variantId.value = variant.id;
      const selectedValues = Array.from(form.querySelectorAll('[data-product-option] input:checked')).map((input) => input.value.toLowerCase());
      const winter = selectedValues.some((value) => value.includes("hiver") || value.includes("winter"));
      productRoot.classList.toggle("shop-hiver", winter);
      productRoot.classList.toggle("shop-ete", !winter);
      if (priceNode) priceNode.textContent = money(variant.price);
      if (unitPriceNode) unitPriceNode.textContent = money(variant.price);
      if (casePriceNode) casePriceNode.textContent = money(variant.price * 25);
      if (sku) sku.textContent = variant.sku || translations.unassigned;
      if (barcode) barcode.textContent = variant.barcode || translations.unassigned;
      if (availability) availability.textContent = variant.available ? translations.available : translations.soldOut;
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? translations.addToCart : translations.soldOut;
      if (variant.featured_media) productRoot.querySelector(`[data-media-target="${variant.featured_media.id}"]`)?.click();
      const variantUrl = new URL(location.href);
      variantUrl.searchParams.set("variant", variant.id);
      history.replaceState({}, "", variantUrl.toString());
      updateTotal();
    };

    const updateTotal = () => {
      const quantity = Math.max(1, Number(quantityInput.value || 1));
      quantityInput.value = quantity;
      if (totalNode) totalNode.textContent = money(currentVariant.price * quantity);
      updateProductProgress();
    };

    form.addEventListener("change", (event) => {
      if (!event.target.matches('[data-product-option] input')) { if (event.target === quantityInput) updateTotal(); return; }
      const options = Array.from(form.querySelectorAll('[data-product-option] input:checked')).map((input) => input.value);
      const matched = variants.find((variant) => variant.options.every((value, index) => value === options[index]));
      if (matched) updateProduct(matched);
    });
    form.querySelector("[data-quantity-minus]")?.addEventListener("click", () => { quantityInput.value = Math.max(1, Number(quantityInput.value) - 1); updateTotal(); });
    form.querySelector("[data-quantity-plus]")?.addEventListener("click", () => { quantityInput.value = Math.min(500, Number(quantityInput.value) + 1); updateTotal(); });
    form.querySelectorAll("[data-quick-quantity]").forEach((button) => button.addEventListener("click", () => { form.querySelectorAll("[data-quick-quantity]").forEach((item) => item.classList.remove("is-active")); button.classList.add("is-active"); quantityInput.value = button.dataset.quickQuantity; updateTotal(); }));
    quantityInput.addEventListener("input", updateTotal);

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (addButton?.disabled) return;
      form.classList.add("is-loading");
      try {
        const response = await fetch(`${rootUrl}cart/add.js`, { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || translations.addError);
        if (status) status.textContent = translated(translations.productAdded, { __PRODUCT__: result.product_title || "ForgeMoly" });
        await openCart();
      } catch (error) { if (status) status.textContent = error.message; addLabel.textContent = error.message; }
      finally { form.classList.remove("is-loading"); }
    });
    updateTotal();
  });

  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    gallery.querySelectorAll("[data-media-target]").forEach((button) => button.addEventListener("click", () => { const id = button.dataset.mediaTarget; gallery.querySelectorAll("[data-media-id]").forEach((media) => { media.hidden = media.dataset.mediaId !== id; }); gallery.querySelectorAll("[data-media-target]").forEach((item) => item.classList.toggle("is-active", item === button)); }));
    gallery.querySelector("[data-gallery-zoom]")?.addEventListener("click", () => gallery.classList.toggle("is-zoomed"));
  });

  document.querySelector("[data-sort-by]")?.addEventListener("change", (event) => { const url = new URL(location.href); url.searchParams.set("sort_by", event.target.value); location.assign(url.toString()); });
  document.querySelector("[data-filter-open]")?.addEventListener("click", () => document.querySelector("[data-filter-panel]")?.classList.toggle("is-open"));
  document.querySelectorAll("[data-cart-shipping]").forEach((node) => updateShipping(node, Number(node.dataset.count || 0)));
})();
